import React, { useState } from 'react'
import TextField from '@mui/material/TextField';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { toast } from 'react-toastify';
import Api from '../../Components/Api';
import { useHistory } from 'react-router';
import jwt_decode from "jwt-decode";
import { connect } from 'react-redux';
import { careers } from '../../Redux/actions/customer';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
var CryptoJS = require("crypto-js");

function CareersInputs(props:any) {
    const history = useHistory();
    const [isChecked, setIsChecked] = useState(false);
    const [disable, setDisable] = useState(true);

    const [phonenumber, setPhonenumber] = useState(false)
    const [phonError, setphonError] = useState(false)

    const [body, setBody] = useState({
        name: "",
        dob: "",
        country_of_birth: "",
        city_of_birth: "",
        cnic: "",
        cnic_expire: "",
        marital_status: "",
        gender: "",
        religion: "",
        disability: "",
        phone_number: "",
        address: "",
        country: "",
        state: "",
        city: "",
        reference: "",
        apply_city: "",
        job_position: "",
        type_of_shift: "",
        type_of_employment: "",
        degree: "",
        major_subjects: "",
        qualification_year: "",
        place_of_tution: "",
        total_experience: "",
        recent_position: "",
        recent_company: "",
        signup_check: 1,
    })

    const handleChange = (e: any) => {
        if (e.target.name != "phone_number" && e.target.name != "dob" && e.target.name != "cnic") 
            setBody({ ...body, [e.target.name]: e.target.value })
        const hasEmptyValue = Object.values(body).some(value => value == '');
        if (hasEmptyValue || !e.target.value) {
            setDisable(true)
        }
        else {
            setDisable(false)
        }

    }
    const handleEnterPress = (e: any) => {
        if (e.key === 'Enter') {
            const hasEmptyValue = Object.values(body).some(value => value === '');
            if (hasEmptyValue) {
                toast.error("Please fill all fields")
            } else {
                handleSubmit();
            }
        }
    }

    const handleSubmit = () => {
        setDisable(true);
        props.careers(body,history)
        
    }

    const handleCheckboxChange = (e: any) => {
        setIsChecked(!isChecked);
    };

    const handlePhone = (e: any) => {
        const { value } = e.target;
        if (value.length <= NUMBERS_LIMIT) {
            setBody({ ...body, [e.target.name]: value })
            setPhonenumber(value);
        }
        if (!checkPhone(value)) return;
        if (value.length == NUMBERS_LIMIT) {
            setphonError(false);
        }
        if (value.length < NUMBERS_LIMIT) {
            setphonError(true);
        }
    };

    const handleDate = (e:any) => {
        const selectedDate = e.target.value;
        const currentDate = new Date().toISOString().split('T')[0];

        if (selectedDate <= currentDate) {
            setBody({ ...body, [e.target.name]: e.target.value })
        } else {
            toast.error("You can't select Future Date")
            setBody({ ...body, [e.target.name]: "" })

        }
    }

    const handleCinic = (e: any) => {
        if (e.target.value.length <= 13) {
            setBody({ ...body, [e.target.name]: e.target.value })
        }
    }
    const { t } = useTranslation();

    return (
        <div className='container mb-5'>
            <h2 className='our-title mt-5'>{t("CAREERS")}</h2>

            <div className="row justify-content-around">
                <div className="col-md-8">
                    <h5 className='careers-title'><i className="ri-user-3-fill"></i>{t("PERSONNEL_INFO")}</h5>
                    <div className=''>
                        <div className="row">
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name='name' onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("FULLNAME")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField type='date'
                                    value={body.dob}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e: any) => {
                                        handleChange(e);
                                        handleDate(e);
                                    }}
                                    name="dob"
                                    onKeyPress={handleEnterPress}
                                    className='field-style' id="filled-basic"
                                    label={`${t("DOB")} *`}
                                    variant="filled"
                                    color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="country_of_birth" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={t("COUNTRY_OF_BIRTH")} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="city_of_birth" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={t("CITY_OF_BIRTH")} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={(e: any) => {
                                    handleChange(e);
                                    handleCinic(e);
                                }}
                                    type='number'
                                    value={body.cnic}
                                    name="cnic" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label="CNIC *" variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField
                                    type='date'
                                    onChange={handleChange} name="cnic_expire"
                                    onKeyPress={handleEnterPress} className='field-style'
                                    id="filled-basic" label="CNIC Expiry Date *"
                                    variant="filled" color="error"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className="col-md-6 mt-4">
                                <FormControl className='field-style' variant="filled" color="error">
                                    <InputLabel id="demo-simple-select-filled-label">{t("MARITAL_STATUS")} *</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        name="marital_status"
                                        value={body.marital_status}
                                        onChange={handleChange}
                                        className='field-style'
                                    >
                                        <MenuItem value={"Married"}>{t("MARRIED")}</MenuItem>
                                        <MenuItem value={"Un Married"}>{t("UN_MARRIED")} </MenuItem>
                                       
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-6 mt-4">
                                <FormControl className='field-style' variant="filled" color="error">
                                    <InputLabel id="demo-simple-select-filled-label">{t("GENDER")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-filled-label"
                                        id="demo-simple-select-filled"
                                        name="gender"
                                        value={body.gender}
                                        onChange={handleChange}
                                        className='field-style'
                                    >

                                        <MenuItem value={"Male"}>{t("MALE")}</MenuItem>
                                        <MenuItem value={"Female"}>{t("FEMALE")}</MenuItem>
                                        <MenuItem value={"Others"}>{t("OTHERS")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="religion" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("RELIGION")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="disability" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("DISABILITY")} *`} variant="filled" color="error" />
                            </div>
                        </div>

                    </div>
                </div>


            </div>

            <div className="row justify-content-around">
                <div className="col-md-8">
                    <h5 className='careers-title'><i className="ri-map-pin-2-fill"></i> Address</h5>
                    <div className=''>
                        <div className="row">
                            <div className="col-md-6 mt-4">
                                <TextField
                                    type='text'
                                    helperText={phonError ? t("PHONE_ERROR",{limit:NUMBERS_LIMIT}) : ""}
                                    value={body.phone_number}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                        handlePhone(e)
                                    }} name="phone_number" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("PHONE_NUMBER")} (${MOBILE_STARS}) *`} variant="filled" color="error"
                                    InputProps={{
                                        startAdornment: <InputAdornment className='font-normal number-field' position="start">{PHONE_CODE}</InputAdornment>,
                                    }}
                                />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="address" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("ADDRESS")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="country" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("COUNTRY")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="state" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label="State/Province *" variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="city" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("CITY")} *`} variant="filled" color="error" />
                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <div className="row justify-content-around">
                <div className="col-md-8">
                    <h5 className='careers-title'><i className="ri-briefcase-line"></i> {t("JOB_POSTING")}</h5>
                    <div className=''>
                        <div className="row">
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="reference" onKeyPress={handleEnterPress} className='field-style' id="filled-basic"  label={`${t("REFERENCE_SOURCE")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="apply_city" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("APPLY_CITY")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="job_position" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("JOB_POSITION")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="type_of_shift" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("TYPE_OF_SHIFT")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="type_of_employment" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("TYPE_OF_EMPLOYMENT")} *`} variant="filled" color="error" />
                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <div className="row justify-content-around">
                <div className="col-md-8">
                    <h5 className='careers-title'>{t("QUALIFICATION")}</h5>
                    <div className=''>
                        <div className="row">
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="degree" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("DEGREE")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="major_subjects" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("MAJORS")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="qualification_year" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("QUALIFICATION_YEAR")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="place_of_tution" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("PLACE_OF_TUITION")} *`} variant="filled" color="error" />
                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <div className="row justify-content-around">
                <div className="col-md-8">
                    <h5 className='careers-title'><i className="ri-star-fill"></i> {t("EXPERIENCE")}</h5>
                    <div className=''>
                        <div className="row">
                            <div className="col-md-6 mt-4">
                                <TextField type='number' onChange={handleChange} name="total_experience" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("TOTAL_EXPERIENCE")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="recent_position" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("RECENT_POSITION")} *`} variant="filled" color="error" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <TextField onChange={handleChange} name="recent_company" onKeyPress={handleEnterPress} className='field-style' id="filled-basic" label={`${t("RECENT_COMPANY")} *`} variant="filled" color="error" />
                            </div>

                        </div>

                    </div>
                </div>


            </div>

            <div className="row justify-content-around">
                <div className="col-md-8">
                    <div className=''>
                        <div className="row">
                            <h2 className='our-title mt-5'>{t("APPLICANT_AGREEMENT_TITLE")}</h2>
                            <p className='applicant-terms mt-4'>{t("APPLICANT_AGREEMENT_TEXT")}</p>
                        </div>
                        <FormGroup>
                            <FormControlLabel className='color-white signup-text'
                                control={<Checkbox
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                    className='color-theme' />} label={t("SIGNUP_REWARDS")} />
                        </FormGroup>
                        <Button onClick={handleSubmit} disabled={(!isChecked || disable || phonError) ? true : false}
                            className={`${(!isChecked || disable || phonError) ? "disable-btn " : "able-btn"} w-50 p-2 m-auto d-flex mt-4 font-medium h2`} variant="contained" color="error"> {t("APPLY")}</Button>
                    </div>
                </div>


            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        careers: function (data: any, history?: any) {
            dispatch(careers(data, history));
        }
    }
}
export default connect(null, mapDispatchToProps)(CareersInputs);
